var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineMissingPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.7059 23.4032L23.1176 17.6719H31.3529",
  className: "chart-qualitative-02-stroke",
  strokeWidth: 1.5,
  strokeLinecap: "square"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.23529 26.0289H8.05882L13.7059 12.8945H21.2353H31.5882",
  stroke: "#007AC9",
  strokeWidth: 1.5,
  strokeLinecap: "square"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V32H33",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})));
export { SvgLineMissingPoint as ReactComponent };
export default __webpack_public_path__ + "line_missing_point.d4e6421d54fbc56fd1215c65e4b6f33a.svg";